import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { Divider } from '@material-ui/core';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import CalendarMarkers from './CalendarMarkers';
import SmartButton from '../../../shared/components/SmartButton';
import CalendarCycles from './CalendarCycles';
import OptionsTerms from './OptionsTerms';
import RenderField from '../../../shared/components/form/RenderField';
import validate from './Validate';

const AcademicCalendarForm = (props) => {
  const {
    t,
    backHandler,
    handleSubmit,
    dto,
    listOfTerms,
    initialize,
    dispatch,
    selectCalendar,
    selectCycle,
    calendarMarkers,
    calendarCycles,
    onChangeCalendarCycles,
    onChangeSelectedTerm,
    onChangeCalendarDays,
    calendarDays,
    totalSchoolDay,
  } = props;

  useEffect(() => {
    initialize(dto);
  }, [dto]);

  return (
    <form onSubmit={handleSubmit}>
      <div className="form border p-3">
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.calendar-name')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="name"
              component={RenderField}
              type="text"
              maxLength="100"
              placeholder={t('general.placeholders.name')}
            />
          </div>
        </div>
        <Divider variant="middle" />
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.school-term-calendar')}
          </span>
          <div className="form__form-group-field">
            <Field
              dto={dto}
              name="schoolTerm"
              component={OptionsTerms}
              terms={listOfTerms}
              handleChange={onChangeSelectedTerm}
            />
          </div>
        </div>
        <Divider variant="middle" />
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.quantity-cycles')}
          </span>
          <div className="form__form-group-field">
            <CalendarCycles
              name="stepQuantity"
              dto={dto}
              showDialog={selectCycle}
              calendarCycles={calendarCycles}
              onChangeCalendarCycles={onChangeCalendarCycles}
              onChangeCalendarDays={onChangeCalendarDays}
              calendarDays={calendarDays}
              dispatch={dispatch}
            />
          </div>
        </div>
        <Divider variant="middle" />
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.marking')}</span>
          <div className="form__form-group-field">
            <CalendarMarkers
              showDialog={selectCalendar}
              calendarMarkers={calendarMarkers}
            />
          </div>
        </div>
      </div>
      {totalSchoolDay ? (
        <div>
          <div className="mt-3 mb-3 total-school-days-description">
            <p>
              <strong>{t('general.total-school-days')}</strong>
              <span className="pl-1 pr-1">{totalSchoolDay}</span>
              {t('general.days')}
            </p>
          </div>
        </div>
      ) : null}
      <ButtonToolbar className="mb-4">
        <SmartButton
          color="primary"
          label={t('general.back')}
          onClick={backHandler}
        />
        <SmartButton color="success" label={t('general.save')} type="submit" />
      </ButtonToolbar>
    </form>
  );
};

AcademicCalendarForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  onChangeCalendarCycles: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  selectCalendar: PropTypes.func.isRequired,
  selectCycle: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  listOfTerms: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  calendarMarkers: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  calendarCycles: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  onChangeSelectedTerm: PropTypes.func.isRequired,
  onChangeCalendarDays: PropTypes.func.isRequired,
  calendarDays: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  totalSchoolDay: PropTypes.number.isRequired,
};

export default reduxForm({
  form: 'AcademicCalendarForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(
  withTranslation('common')(
    connect((state) => ({
      loading: state.loading,
    }))(memo(AcademicCalendarForm))
  )
);
